import React, { useMemo, useState } from "react";
import { Grid, GridItem, Spinner, Text, } from "@chakra-ui/react";
import "../../App.css";
import ScenarioCard from "../../components/ScenarioCard";
import { IExerciserSDK } from "ap-exerciser-sdk";
import { Tag } from "../../constants/Scenario";
import { SquidexScenarioData } from "ap-exerciser-sdk/models";
import { useVocabIntl } from "../../hooks/useVocabTranslation";

interface ScenarioTabContentProps {
  sdk: IExerciserSDK;
  tag: Tag;
  onStart: (scenarioId?: string) => void;
}

function ScenarioTabContent({ sdk, tag, onStart }: ScenarioTabContentProps) {
  const { getFormattedString } = useVocabIntl()
  const [loading, setLoading] = useState<boolean>(false);
  const [scenarios, setScenarios] = useState<SquidexScenarioData[]>([]);

  if (!loading && sdk && scenarios.length === 0) {
    setLoading(true);
    sdk.getDataManager().getScenariosWithTag(tag.value).then(data => {
      if (data && data.length > 0) {
        setScenarios([...data].sort((a, b) => a?.name?.localeCompare(b?.name)));
      } else {
        setScenarios([]);
      }
    }).finally(() => setLoading(false))
  }

  return (
    <>
      <Text sx={{ fontSize: "1rem", fontWeight: 700, color: "black" }}>
        {tag.label}
      </Text>
      <Text sx={{ fontSize: "0.875rem", fontWeight: 400, color: "black" }}>
        {getFormattedString('exercises-list-subtitle', {
          year: +(tag.value.replace("primary_", "")) || 1
        })}
      </Text>
      {loading &&
          <Spinner size={"lg"} emptyColor={"secondary.fg"} color={"primary.fg"} alignSelf={"center"} marginTop={"4"} />}
      <Grid templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)" }} columnGap={2} rowGap={2}
            height={"fit-content"} maxHeight={"100%"} overflowY={"auto"}
            style={{ scrollbarGutter: "stable both-edges" }}
            paddingX={"0.25rem"} margin={"0.5rem -0.4rem"}>
        {useMemo(() => {
          return scenarios.map((scenario: any, index) => (
            <GridItem key={scenario.id} height={"min-content"}>
              <ScenarioCard
                name={scenario.name}
                tags={[tag.label]}
                id={scenario.id}
                onStart={onStart}
              />
            </GridItem>
          ))
        }, [scenarios])
        }
      </Grid>
    </>);
}

export default ScenarioTabContent;
